/*
**  rui-toggle-button.js
**
**  rui-toggle-button component
*/
import { LitElement, html, css } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ruiCommonStylesButtons } from '../common/rui-common-styles-buttons.js';
export class RuiToggleButton extends LitElement {
    static get is() {
        return 'rui-toggle-button';
    }
    static get properties() {
        return {
            value: { type: Object },
            buttonSize: { type: String },
            isDisabled: { type: Object }
        };
    }
    constructor() {
        super();
        this.value = false;
        this.buttonSize = 'medium';
        this.isDisabled = false;
    }
    toggleValue(e) {
        e.preventDefault();
        e.stopPropagation();
        // Let other components know that a popup toggle has been clicked
        // so they can close their popup menus if open
        let toggleClickEvent = new CustomEvent('rui-toggle-click', {
            detail: {},
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(toggleClickEvent);
        if (!this.isDisabled) {
            // Store new value
            this.value = !this.value;
            // Fire value change event
            let valueChangeEvent = new CustomEvent('rui-value-change', {
                detail: this.value,
                bubbles: true,
                composed: true
            });
            this.dispatchEvent(valueChangeEvent);
        }
    }
    render() {
        const classes = {
            ['rui-btn']: true,
            ['rui-btn-secondary']: true,
            ['rui-toggle-btn']: true,
            ['rui-toggle-button-on']: this.value,
            ['rui-btn-sm']: this.buttonSize.toLowerCase() === 'small'
        };
        return html `
            <button class="${classMap(classes)}" ?disabled="${this.isDisabled}" @click="${this.toggleValue}">
                <slot></slot>
            </button>
        `;
    }
    static get styles() {
        return [
            ruiCommonStylesButtons,
            css `
                .rui-toggle-button-on {
                    background-color: var(--rui-btn-toggle-bg-on, #ccdfff);
                    color: var(--rui-btn-toggle-fg, #09175b);
                }

                .rui-toggle-button-on:hover,
                .rui-toggle-button-on:focus,
                .rui-toggle-button-on:active {
                    background-color: var(--rui-btn-toggle-bg-on-hover, #b3cfff);
                    color: var(--rui-btn-toggle-fg, #09175b);
                }
            `
        ];
    }
}
RuiToggleButton.shadowRootOptions = { ...LitElement.shadowRootOptions, delegatesFocus: true };
customElements.get(RuiToggleButton.is) || customElements.define(RuiToggleButton.is, RuiToggleButton);
